exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a{\r\n    margin: auto;\r\n    display: block;\r\n    height: 35px;\r\n    line-height: 35px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n.mat-card-footer{\r\n    text-align: center;\r\n}\r\n.mat-card{\r\n    margin:20px 0 10px 0;\r\n    display: none;\r\n}\r\n.mat-card-title{\r\n    font-weight: bold;\r\n    border-bottom: 1px solid;\r\n}\r\n.inline-items{\r\n    margin:10px 10px;\r\n}\r\nul{\r\n    margin-bottom: 0;\r\n}\r\n.form-group{\r\n    margin-bottom: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/list-item/group-item/group-item.component.css
// module id = ../../../../../src/app/list-item/group-item/group-item.component.css
// module chunks = main